module.exports = __webpack_public_path__ + "img/horizontal_7_4_4.6cc4b759.png";